module.exports = __webpack_public_path__ + "static/waves-connect-e716b88663e55eaee310ef2b4e2e670e.svg";